<template>
  <div class="s-buy" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <img v-if="btnBuy.src" :src="btnBuy.src" :style="{...btnBuy.style}" alt="" @click="buyFun">
  </div>
</template>

<script>

import SAnimateImage from '../AnimateImage/index.vue'

export default {
  name: 'SVersionBuy',
  components: { SAnimateImage },
  props: {
    activityId: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    btnBuy: {
      type: Object,
      default: () => {
        return {}
      }
    },
    request: {
      type: Function
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  mounted () {
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.getCheckStatus)
      // 登出操作添加
      this.eventBus.on('signOut', this.reset)
    }
    this.getCheckStatus();
  },
  data () {
    return {
      totalAward: []
    }
  },
  methods: {
    getCheckStatus () {
      // 判断登录
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId }
      }).then((res) => {
        this.totalAward = res.groups
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    },
    reset () {
    },
    // 点击立即购买代币
    buyFun () {
      // 判断登录
      if (!window.$checkLogin()) return
      this.$MainWrap.openVersionDialogTip({
        title: '提示',
        content: '是否消耗点券购买' + this.totalAward[0].name,
        btnConfirmText: '确定',
        btnCancelText: '取消',
        onConfirm: () => {
          this.confirmBuy(this.totalAward)
        },
        onCancel: () => {}
      })
    },
    // 确认购买信息
    confirmBuy (items) {
      this.requestAPI({
        url: '/v1/uni/receive',
        method: 'get',
        params: { a_id: this.activityId, g_id: items[0].id }
      }).then((res) => {
        this.$MainWrap.openVersionDialogTipSuccess(res.gift.materials)
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.s-buy{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
</style>
